import { Outlet } from '@tanstack/react-router'
import { useMemo } from 'react'
import { TooltipProvider } from '@/components/ui/tooltip'
import { useAuthedMe } from '@/features/auth/api'
import { BrandingEffect, TenantLogo } from '@/features/integrations/components/branding-effect'
import { EmergencyBanner } from '@/features/emergency/components/emergency-banner'
import { UploadTray } from '@/features/media/components/upload-tray'
import { PairingDialog } from '@/features/pairing/components/pairing-dialog'
import { ScheduleEditorSheet } from '@/features/schedules/components/schedule-editor-sheet'
import { CommandPalette } from './components/command-palette'
import { ImpersonationBanner } from './components/impersonation-banner'
import { MobileNav } from './components/mobile-nav'
import { PlanFooter } from './components/plan-footer'
import { Sidebar } from './components/sidebar'
import { TenantSwitcher } from './components/tenant-switcher'
import { Topbar } from './components/topbar'
import { UpgradeDialog } from './components/upgrade-dialog'
import { APP_NAV, filterNav } from './nav'

export function AppLayout() {
  const me = useAuthedMe()
  const features = me.subscription?.entitlements.features
  const sections = useMemo(() => filterNav(APP_NAV, me.permissions, features), [me.permissions, features])
  return (
    <TooltipProvider>
      <div className="flex min-h-dvh flex-col">
        <ImpersonationBanner />
        <EmergencyBanner />
        <div className="flex flex-1">
          <Sidebar sections={sections} footer={(collapsed) => <PlanFooter collapsed={collapsed} />} />
          <MobileNav sections={sections} footer={<PlanFooter collapsed={false} />} />
          <div className="flex min-w-0 flex-1 flex-col">
            <Topbar
              left={
                <div className="flex min-w-0 items-center gap-2">
                  <TenantLogo />
                  <TenantSwitcher />
                </div>
              }
            />
            <main id="main" className="flex-1">
              <Outlet />
            </main>
          </div>
        </div>
        <CommandPalette sections={APP_NAV} />
        <PairingDialog />
        <ScheduleEditorSheet />
        <UpgradeDialog />
        <UploadTray />
        <BrandingEffect />
      </div>
    </TooltipProvider>
  )
}
